import ScrollReveal from 'scrollreveal';

class WhizzBang {
    constructor() {
        // on doc loaded, initialize scrollreveal and dispatch event
        // for other modules to listen to and use.
        document.addEventListener('DOMContentLoaded', () => {
            const sr = ScrollReveal({ delay: 100, duration: 1200 });
            const event = new CustomEvent('scrollreveal:init', { detail: { sr } });
            document.dispatchEvent(event);
        });
    }
}

export default WhizzBang;
